import Translation from 'lib/helpers/translation';

const companyTranslations = {
  ...Translation.group('cmsCompany')
};

const vesselTranslations = {
  ...Translation.group('cmsVessel')
};

const faqMainTranslations = {
  ...Translation.group('cmsFaqMain')
};

const faqTranslations = {
  ...Translation.group('cmsFaq')
};

const faqCommonTranslations = {
  ...Translation.group('cmsFaqCommon')
};

const blogCommonTranslations = {
  ...Translation.group('cmsBlogCommon')
};

const ferryRoutesTranslations = {
  ...Translation.group('cmsFerryRoutes')
};

const ferryRouteTranslations = {
  ...Translation.group('cmsFerryRoute')
};

const destinationCommonTranslations = {
  ...Translation.group('cmsDestinationCommon')
};

const destinationTranslations = {
  ...Translation.group('cmsDestination')
};

const ferryVesselsTranslations = {
  ...Translation.group('cmsFerryVessels')
};

const ferryPriceTranslations = {
  ...Translation.group('cmsPrice')
};

const ferryCabinSeatTranslations = {
  ...Translation.group('cmsCabinSeat')
};

const ferryAgencyTranslations = {
  ...Translation.group('cmsFerryAgency')
};

const schedulesTranslations = {
  ...Translation.group('cmsSchedules')
};

export {
  companyTranslations,
  vesselTranslations,
  faqCommonTranslations,
  faqMainTranslations,
  faqTranslations,
  blogCommonTranslations,
  ferryRoutesTranslations,
  ferryRouteTranslations,
  destinationCommonTranslations,
  destinationTranslations,
  ferryVesselsTranslations,
  ferryPriceTranslations,
  ferryCabinSeatTranslations,
  ferryAgencyTranslations,
  schedulesTranslations
};
